module.exports = __webpack_public_path__ + "media/images/icon_home_non-public-3dfe84d0756e0b36f1b567f56d204e83.svg";